import { FormGroup, required } from "components/common";
import { Trans } from "react-i18next";
import Select from "react-select";
import { LocalForm, Control } from "react-redux-form";
import { vat_types, vat_reasons } from "./constants";
import { Alert, Button, Col, Row, Input, Spinner } from "reactstrap";
import { useMemo, useState } from "react";

export default function ExemptionModal({ toggle, updateReasons, t, zeroRateLines, isBulk = false }) {
    const [lineReasons, setLineReasons] = useState({});
    const [loading, setLoading] = useState(false);

    const lineReasonsList = useMemo(() => {
        const lineReasonList = Object.entries(lineReasons?.ZeroTaxReasons || {}).map(([line_id, value]) => ({
            line_id,
            ...value
        }));
        return lineReasonList
    }, [lineReasons?.ZeroTaxReasons]);

    const hasDuplicateTypes = (single = false, type = null) => {
        const typeCount = lineReasonsList.reduce((acc, item) => {
            if (item.vatType) {
                acc[item.vatType] = (acc[item.vatType] || 0) + 1;
            }
            return acc
        }, {});

        if (single) {
            return typeCount[type] > 1;
        }

        return Object.values(typeCount).some(count => count > 1);
    };


    const isOtherTypeSelected = (line_id) => {
        return lineReasonsList.some((i) => i.line_id !== line_id && i.vatType === lineReasons?.ZeroTaxReasons[line_id]?.vatType && i.mainComponent)
    }
    const isTypeSelected = (reason) => {
        return lineReasonsList.some((i) => reason.vatType === i.vatType && i.mainComponent)
    }

    const isFormValid = () => {
        if (!hasDuplicateTypes())
            return true
        return lineReasonsList?.filter((reason) => hasDuplicateTypes(true, reason.vatType)).every((reason) => { return isTypeSelected(reason) })
    }

    const performUpdate = async (values) => {
        setLoading(true);
        await updateReasons(values);
        setLoading(false)
    }


    return (
        <>
            <Alert color="info">
                <Trans>You're submitting a document with zero rate lines, please specify the type and the reason for each line</Trans>
            </Alert>

            {
                hasDuplicateTypes() &&
                <Alert color="warning">
                    <Trans>You have duplicate vat types, please set a primary item </Trans>
                </Alert>
            }

            <LocalForm
                initialState={{}}
                onSubmit={performUpdate}
                onChange={(values) => { setLineReasons(values) }}
                validators={{
                }}
            >
                <div className="">
                    <Row>
                        <Col className={`${hasDuplicateTypes() ? 'col-3' : 'col-4'}`}>
                            <FormGroup label={t("Line Description") + " *"} addControlClass={false} className="my-1">
                            </FormGroup>
                        </Col>
                        <Col className={`${hasDuplicateTypes() ? 'col-3' : 'col-4'}`}>
                            <FormGroup label={t("Vat type") + " *"} addControlClass={false} className="my-1">
                            </FormGroup>
                        </Col>
                        <Col className="col-4">
                            <FormGroup label={t("Exempt Reason") + " *"} addControlClass={false} className="my-1">
                            </FormGroup>
                        </Col>
                        {hasDuplicateTypes() &&
                            <Col className="col-2">
                                <FormGroup label={t("Main Item") + " *"} addControlClass={false} className="my-1">
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    {zeroRateLines.map((line, index) => (
                        <Row className="my-2">
                            <Col className={`${hasDuplicateTypes() ? 'col-3' : 'col-4'}`}>
                                <FormGroup >
                                    <Input
                                        type="text"
                                        defaultValue={line.Description}
                                        disabled={true}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className={`${hasDuplicateTypes() ? 'col-3' : 'col-4'}`}>
                                <FormGroup addControlClass={false}>
                                    <Control.select
                                        component={Select}
                                        model={`.ZeroTaxReasons.${line.LineItemID}.vatType`}
                                        clearable={false}
                                        options={vat_types()}
                                        simpleValue
                                        validators={{ required }}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            {lineReasons.ZeroTaxReasons?.[line.LineItemID]?.vatType === "Outside scope of tax / Not subject to VAT services" ?
                                <Col className="col-4">
                                    <FormGroup >
                                        <Control.text
                                            type="text"
                                            model={`.ZeroTaxReasons.${line.LineItemID}.vatReason`}
                                            validators={{ required }}
                                            placeholder={t("Type a custom exempt reason...")}
                                            required
                                            defaultValue={''}
                                        />
                                    </FormGroup>
                                </Col>
                                :
                                <Col className="col-4">
                                    <FormGroup addControlClass={false}>
                                        <Control.select
                                            component={Select}
                                            model={`.ZeroTaxReasons.${line.LineItemID}.vatReason`}
                                            clearable={false}
                                            options={vat_reasons(lineReasons.ZeroTaxReasons?.[line.LineItemID]?.vatType)}
                                            simpleValue
                                            validators={{ required }}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            }
                            {hasDuplicateTypes(true, lineReasons.ZeroTaxReasons?.[line.LineItemID]?.vatType) &&
                                <Col className="col-2 text-center pt-2">
                                    <Control.checkbox disabled={isOtherTypeSelected(line.LineItemID)} defaultChecked={false} model={`.ZeroTaxReasons.${line.LineItemID}.mainComponent`} />
                                </Col>
                            }
                        </Row>
                    ))}
                </div>
                <div className="clearfix mt-3">
                    <Control.button component={({ disabled, ...props }) => <Button {...props} disabled={disabled || !isFormValid()}>
                        {loading && <Spinner size="sm" color="light" />} {isBulk ? t("Update") : t("Update")}
                    </Button>}
                        model="."
                        className="float-right mr-0"
                        disabled={{ valid: false }} />
                </div>
            </LocalForm>
        </>
    )
}